export default __webpack_public_path__ + "static/media/emailPhoneChange.be5b7ef4.svg";